
var site = site || {};
site.Search = (() => {
    const searchTrigger = document.querySelector('.js-search-toggle');
    
    const searchResults = () => {
        const searchSubmitButtons = document.querySelectorAll('.js-submit-search');
        searchSubmitButtons.forEach((searchButton) => {
            searchButton.addEventListener('click', (e) => {
                e.preventDefault();
                location.href = '/search?keyword=' + searchButton.previousElementSibling.value;
            })
        });
        
        
        const keywordInputField = document.querySelectorAll('.js-keyword');
        keywordInputField.forEach((el, i) => {
            el.addEventListener('keyup', (e) => {
                if (e.keyCode == 13) {
                    let keyword = el.value;
                    let url = "/search?keyword=" + keyword;
                    location.href = url;
                }
            })
        });
    }
    
    const predictiveSearch = () => {
        const searchInputs = document.querySelectorAll('.js-searchTerm');
        const dataList = document.getElementById('searchResultsDatalist');

        searchInputs.forEach((input) => {
            input.addEventListener('input', function () {
                let searchQuery = this.value;
                if (searchQuery.length >= 3) {
                    // Make a POST request to the suggest endpoint with search text
                    fetch('/AzureSearch/Suggest', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ searchText: searchQuery, fuzzy: true })
                    })
                        .then(response => response.json())
                        .then(suggestions => {
                            // Clear existing datalist options
                            dataList.innerHTML = '';

                            // Add new suggestions to the datalist
                            suggestions.forEach(suggestion => {
                                const option = document.createElement('option');
                                option.value = suggestion;
                                dataList.appendChild(option);
                            });
                        })
                        .catch(error => {
                            console.error('Error fetching suggestions:', error);
                        });
                } else {
                    dataList.innerHTML = '';
                }
            });
        });
    };

    const highlightSearchQuery = () => {
        if (document.querySelector('.js-search-results')) {
            const searchQuery = document.querySelector('.js-searchTerm').value
            const regEx = new RegExp(searchQuery, "gi")
            const searchResultsContentItems = document.querySelectorAll('.js-search-results-content')
            
            searchResultsContentItems.forEach((contentItem) => {
                const content = contentItem.textContent.trim();
                contentItem.innerHTML = content.replaceAll(regEx, '<mark>$&</mark>')
            })
        }
    }

    searchTrigger.addEventListener('click', () => {
        setTimeout(() => {
            document.querySelector('#headerKeyword').focus()
        }, 500);
    })

    // Return
    return {
        searchResults: searchResults,
        predictiveSearch: predictiveSearch,
        highlightSearchQuery: highlightSearchQuery
    };
})();